
export { submitAccountForm, toggleChangePassword };

var toggleChangePassword = function () {
	$("#changePasswordWrapper").toggle().find('input').val('');
};

var submitAccountForm = function(){

	var success = function(data){
		if (data[0] === 0) {
			$("#accountFormMessage").removeClass('error_message').addClass('success').text('Account data updated.');
		} else {
			$("#accountFormMessage").removeClass('success').addClass('error_message').text(data[1]);
		}
	};

	var validate = function(){
		var errors = [];
		$('#accountFormMessage').html('&nbsp;');
		if (formData.firstName.length < 1) {
			errors.push('First Name cannot be empty.');
		}
		if (formData.lastName.length < 1) {
			errors.push('Last Name cannot be empty.');
		}
		if (formData.email.length < 1) {
			errors.push('E-mail cannot be empty.');
		} else if (!validateEmail(formData.email)) {
			errors.push('Please enter a valid e-mail address.');
		}
		if (formData.pwn || formData.pwn_verify) {
			if (formData.pwn !== formData.pwn_verify) {
				errors.push('New password fields do not match.');
			} else if (formData.pw.length < 1) {
				errors.push('Please enter your current password.');
			}
		}
		if (errors.length) {
			$('#accountFormMessage').removeClass('success').addClass('error_message');
			errors.map( function(error){
				$('#accountFormMessage').append(error + "<br/>");
			} );
			return false;
		}
		return true;
	};

	var	validateEmail = function($email){
		var emailReg = /^([\w-+.]+@([\w-]+\.)+[\w-]{2,4})?$/;
		return emailReg.test($email);
	};

	// concatenate checkbox selections into strings
	var formData = {},
		posLevel = "",
		orgLevel = "",
		teamGender = "",
		posLevelChoices = [
			$('#level_uni'),
			$('#level_jc'),
			$('#level_hs'),
			$('#level_ms'),
			$('#level_club'),
			$('#level_other')
		],
		orgLevelChoices = [
			$('#level2_v'),
			$('#level2_jv'),
			$('#level2_c18'),
			$('#level2_c16'),
			$('#level2_c14'),
			$('#level2_c12')
		],
		teamGenderChoices = [
			$('#gender_male'),
			$('#gender_female')
		],
		checked = [],
		i;

	for (i = 0; i < posLevelChoices.length; i++) {
		if (posLevelChoices[i].attr('checked')) {
			checked.push(posLevelChoices[i].val());
		}
	}
	posLevel = checked.join();
	checked = [];
	for (i = 0; i < orgLevelChoices.length; i++) {
		if (orgLevelChoices[i].attr('checked')) {
			checked.push(orgLevelChoices[i].val());
		}
	}
	orgLevel = checked.join();
	checked = [];
	for (i = 0; i < teamGenderChoices.length; i++) {
		if (teamGenderChoices[i].attr('checked')) {
			checked.push(teamGenderChoices[i].val());
		}
	}
	teamGender = checked.join();

	formData = {
		firstName:  $('#first_name').val(),
		lastName:   $('#last_name').val(),
		email:      $('#email').val(),
		city:       $('#city').val(),
		state:      $('#state').val(),
		position:   $('#position').val(),
		posLevel:   posLevel,
		org:        $('#org').val(),
		orgLevel:   orgLevel,
		teamGender: teamGender,
		pw:         $("#change_password_pw").val(),
		pwn:        $("#change_password_pwn").val(),
		pwn_verify: $("#change_password_pwn_verify").val()
	};

	// Do not post to server if validation fails
	if (!validate()) {
		return;
	}

	$.ajax({
		url: "/member/account",
		type: "post",
		data: formData,
		dataType: "json",
		success: success,
		error: function(){
			$("#accountFormMessage").removeClass('success').addClass('error_message').text('An error occurred; please try again later.').show();
		}
	});

};
